import axios from "axios"
import library from "../../../utils/Library"

export const getUniqueEmailsFromSubscriptionDelegationsVE = async () => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("legal_communications") +
    "/getUniqueEmailsFromSubscriptionDelegationsVE"

  return await axios({
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
